import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { Switch } from '../../models/editors/switch.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { ProductCategory } from './../../models/product-categories/product-categories.model';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
import { Contained } from './../../models/editors/contained.model';

@Component({
  selector: 'swb-category-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class ProductCategoryDetailComponent extends FormDetailBase<ProductCategory> implements OnInit {

  public url = 'product-categories';
  protected _redirect = './products';

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název kategorie',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Úvodní text',
        validators: [],
        isMultilang: true,
        wysiwyg: 'category-detail'
      }),
      new Textbox({
        key: 'services_title',
        label: 'SLUŽBY - Titulek',
        validators: [],
        isMultilang: true
      }),
      new Textarea({
        key: 'services_text',
        label: 'SLUŽBY - Popisek',
        validators: [],
        isMultilang: true,
        wysiwyg: 'category-detail-services-1'
      }),
      new Textarea({
        key: 'services_column_1',
        label: 'SLUŽBY - Sloupec 1',
        validators: [],
        isMultilang: true,
        wysiwyg: 'category-detail-services-2'
      }),
      new Textarea({
        key: 'services_column_2',
        label: 'SLUŽBY - Sloupec 2',
        validators: [],
        isMultilang: true,
        wysiwyg: 'category-detail-services-3'
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Switch({
        key: 'show_on_hp',
        label: 'Zobrazit na hlavní straně',
        defaultValue: true
      }),
      new Contained({
        key: 'parent_id',
        label: 'Rodičovská kategorie',
        entity: this.entity?.parent_category,
        upload: false,
        apiUrl: 'product-categories',
        canCreate: false
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }
    this._getEntity();
  }

}
